import React, { useEffect } from 'react';
import liveChatConfig from '../resources/liveChatConfig.json';

export const LiveChatRedirect: React.FC<any> = ({
    disableButtons,
    sendPostBack,
}) => {
    const genesysAuthCode = window?.genesysAuth?.authCode;
    useEffect(() => {
        if (genesysAuthCode && !disableButtons) {
            sendPostBack('/DIRECT-init-live-chat');
        }
    }, [genesysAuthCode, disableButtons, sendPostBack]);

    return (
        <div>
            <p>{liveChatConfig.providence.redirecting}</p>
        </div>
    );
};

export default LiveChatRedirect;
